import { useSmartMutation, useSmartQuery } from "@shared/api/queries/hooks";
import { downloadFile, openPdfInNewTab } from "@shared/utils/utils";
import { downloadBillTemplate, getBillCorrectionDetails, getBillPreview, getTemplates, sendCommunication } from "./api";
import { QueryKeyFactory } from "@shared/api/queries/queryKeyFactory";
import { toast } from "@shared/hooks/use-toast";

export const useDownloadBill = () => {
  return useSmartMutation(
    async ({
      billId,
      filename = "template.pdf",
    }: {
      billId: string;
      filename?: string;
    }) => {
      const blob = await downloadBillTemplate(billId);
      downloadFile(blob, filename);
      return blob;
    }
  );
};

export const useViewBill = () => {
  return useSmartMutation(async (billId: string) => {
    const blob = await downloadBillTemplate(billId);
    openPdfInNewTab(blob);
    return blob;
  });
};

export const useBillDetailsFromCorrection = (remoteUtilityId, correctionId) => {
  return useSmartQuery(
    QueryKeyFactory.module.bx.billCorrection.billCorrectedDetails(correctionId),
    () => getBillCorrectionDetails(remoteUtilityId, correctionId),
    {
      enabled: !!remoteUtilityId && !!correctionId,
    }
  );
};

export const useBillPreview = (draftId?: number) => {
  return useSmartQuery(
    QueryKeyFactory.module.bx.billingPreview(draftId),
    () => downloadBillTemplate(String(draftId)),
    {
      enabled: !!draftId,
    }
  );
};

export const useTemplates = ({
  channelType,
  remoteUtilityId,
}: {
  channelType: string;
  remoteUtilityId: string;
}) =>
  useSmartQuery(
    QueryKeyFactory.module.ux.messaging.templates(channelType),
    () => getTemplates(channelType, remoteUtilityId),
    {
      enabled: !!remoteUtilityId && !!channelType,
    }
  );

  export const useSendCommunication = (id: string) => {
    return useSmartMutation(
      (data: any) => sendCommunication(data),
      {
        onSuccess: () => {
          toast({
            title: "Success",
            description: "Communication sent successfully!",
            variant: "default",
          });
        },
      }
    );
  };
  